import { BrighterionAuthService } from '@brighterionai/br-auth-service';
import { WatchlistScreeningRoleService } from '@brighterionai/br-roles';
// eslint-disable-next-line import/no-mutable-exports
export let AuthService: BrighterionAuthService;
// eslint-disable-next-line import/no-mutable-exports
export let RoleService: any; // any type because In future we may add multiple role values

export function setAuthService(authService: BrighterionAuthService) {
    AuthService = authService;
}

export function setRoleService(roleService: WatchlistScreeningRoleService, userDetails?: User) {
    const { roles } = roleService;

    const hasWLSConfigAdminAccess = roleService.isWlsConfigAdmin();
    const hasWLSListAdminAccess = roleService.isWlsListAdmin();
    const hasWLSAdhocSearchAccess = roleService.isWlsSearch();
    const hasWLSBatchEntity = roleService.isWlsBatchEntity();
    const hasWLSSingleEntity = roleService.isWlsSingleEntity();

    const hasCMRoles = roles.some((role: string) => role.includes('CASE'));
    const hasRMRoles = roles.some((role: string) => role.includes('RM'));
    const hasTMRoles = roles.some((role: string) => role.includes('TM'));

    // Check if user is a landlord (landlordId === tenantKey)
    const isLandlord = !!(userDetails?.landlordId && userDetails?.landlordId === userDetails?.tenantKey);

    RoleService = {
        ...roleService,
        hasWLSConfigAdminAccess,
        hasWLSListAdminAccess,
        hasWLSAdhocSearchAccess,
        hasWLSBatchEntity,
        hasWLSSingleEntity,
        hasCMRoles,
        hasRMRoles,
        hasTMRoles,
        isLandlord
    };
}
